import memberInfo from '../data/member-info';
import antiForgeryToken from '../data/anti-forgery-token';
import BodyContainer from '../ui/layout/body-container';
import SiteHeader from '../ui/layout/site-header';
import SiteHeaderProfile from '../ui/layout/site-header-profile';
import SiteSearch from '../ui/layout/site-search';
import SideMenuUI from '../ui/layout/side-menu-ui';
import SideMenuNotificationsUI from '../ui/layout/side-menu-notifications-ui';
import SiteHeaderNotificationsUI from '../ui/layout/site-header-notifications-ui';
import Navigation from '../ui/layout/navigation';
import ToggleElementsUI from '../ui/toggle-elements';
import NavigationData from '../data/navigation';
import NavigationFilterData from '../data/navigation-filter';
import bootScribeAndMetrics from '../boot/boot-scribe-and-metrics';
import SearchSuggestionService from '../data/search-suggestion-service';
import SearchSuggestion from '../ui/search-suggestion';
import SearchTracking from '../ui/search-tracking';
import MessageBoxUI from '../ui/message-box-ui';
import NavCategoriesUI from '../ui/layout/nav-categories-ui';
import CategoriesSectionUI from '../ui/categories-section-ui';
import GoogleTagManager from '../ui/layout/google-tagmanager';
import disableZoomIfAndroidChrome from '../../utils/disable-zoom';
import WindowResize from '../../utils/window-resize';
import TempData from '../data/temp-data';
import Loading from '../ui/loading';
import ModalUI from '../ui/modal-ui';
import ModalTooltipUI from '../ui/modal-tooltip-ui';
import NavigationModal from '../data/navigation-modal';
import Login from '../ui/layout/login';
import MegaMenuUI from '../ui/layout/mega-menu-ui';
import FeatureFeedbackLink from '../ui/feature-feedback/feature-feedback-link';
import SavedSearchMonitorTogglerUI from '../ui/saved-search-monitor-toggler-ui';
import WindowLoad from '../../utils/window-load';
import WindowScroll from '../../utils/window-scroll';
import PreventDefault from '../../utils/prevent-default';
import HybridAppEvents from '../../utils/hybrid-app-events';
import isHybridAppWithMinBuild from '../../utils/is-hybrid-app-with-min-build';
import Nuggad from '../ui/layout/ads/nuggad';
import GoogleAdsLoader from '../ui/layout/ads/google-ads-loader';
import GptLogger from '../ui/layout/ads/gpt-logger';
import BetaSignupService from '../data/beta-signup-service';
import SignupReferralPathCookieCreator from '../ui/layout/signup-referral-path-cookie-creator';
import TriotFlightBridge from '../../utils/triot-flight-bridge';
import Blueshift from '../../utils/blueshift';
import LogBrokenAds from '../../utils/log-broken-ads';

const enableBlueshift = (initData, Blueshift) => {
    if (initData.featureSwitches && initData.featureSwitches['blueshift-tracking']) {
        Blueshift.attachTo(document, { initData: initData });
    }
}

const enableAds = initData => {
    if (initData.featureSwitches && initData.featureSwitches['google-ads']) {
        if (initData.featureSwitches['ad-metrics']) {
            GptLogger.attachTo(document);
        }
        GoogleAdsLoader.attachTo(document, { initData: initData });
    }

    if (initData.featureSwitches && initData.featureSwitches['broken-ads-tracking']) {
        LogBrokenAds.attachTo(document);
    };
}


const attachFlightComponents = initData => {

    if (initData.enablePushState) {
        Navigation.attachTo(document);
    }

    NavigationFilterData.attachTo(document);
    // this service is needed even when pushstate is disabled
    NavigationData.attachTo(document, { enablePushState: initData.enablePushState, version: initData.version });

    SearchSuggestionService.attachTo(document);
    GoogleTagManager.attachTo(document);

    PreventDefault.attachTo(document.body);
    ModalUI.attachTo(document.body);
    ModalTooltipUI.attachTo(document.body);
    BodyContainer.attachTo(document.body, { initData: initData });
    SiteHeaderNotificationsUI.attachTo('[data-site-header-notifications]');
    SiteHeader.attachTo('[data-site-header]', { initData: initData });
    SiteHeaderProfile.attachTo('[data-site-header-profile]');
    SiteSearch.attachTo('[data-search-field]', { initData: initData });
    SearchSuggestion.attachTo('[data-search-suggestion]');
    SideMenuUI.attachTo('[data-side-menu]');
    SideMenuNotificationsUI.attachTo('[data-side-menu]');
    MessageBoxUI.attachTo('.message-box-wrapper');
    NavCategoriesUI.attachTo('.nav-categories');
    ToggleElementsUI.attachTo('[data-search-filter-box]');
    CategoriesSectionUI.attachTo('.view-categories-category');
    disableZoomIfAndroidChrome();
    WindowResize.attachTo(document);

    TempData.attachTo('#temp-data');
    Loading.attachTo(document);
    NavigationModal.attachTo(document);
    Login.attachTo(document);
    SearchTracking.attachTo(document);
    MegaMenuUI.attachTo(document, { initData: initData });
    FeatureFeedbackLink.attachTo(document, { initData: initData });
    BetaSignupService.attachTo(document);
    SavedSearchMonitorTogglerUI.attachTo(document.body);
    WindowLoad.attachTo(document);
    WindowScroll.attachTo(document);

    if (isHybridAppWithMinBuild(1)) {
        HybridAppEvents.attachTo(document);
    }

    SignupReferralPathCookieCreator.attachTo('[data-reg-user-link]');
    TriotFlightBridge.attachTo(document);

    // do not enable Nuggad for /selling
    if (window.location.pathname.indexOf('/selling') < 0) {
        Nuggad.attachTo(document);
    }
}

export default initData => {
    memberInfo.set(initData);
    antiForgeryToken.set(initData);
    bootScribeAndMetrics(initData);
    attachFlightComponents(initData);
    /* jshint ignore:end */
    enableBlueshift(initData, Blueshift);
    enableAds(initData);
};





// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/boot/boot-layout.js